// User
export const PROFILE_PAGE_PATH = "/profile";
export const SETTINGS_PAGE_PATH = "/settings";
export const DASHBOARD_PAGE_PATH = "/dashboard";

// Commons
export const SIMS_PAGE_PATH = "/sims";
export const ZONES_PAGE_PATH = "/zones";
export const VENDORS_PAGE_PATH = "/vendors";
export const COMPANIES_PAGE_PATH = "/companies";
export const OPERATORS_PAGE_PATH = "/operators";

// Users
export const AGENTS_PAGE_PATH = "/users/agents";
export const ADMINS_PAGE_PATH = "/users/admins";
export const MANAGERS_PAGE_PATH = "/users/managers";
export const OVERSEERS_PAGE_PATH = "/users/overseers";
export const COLLECTORS_PAGE_PATH = "/users/collectors";
export const SUPERVISORS_PAGE_PATH = "/users/supervisors";
export const ACCOUNTANTS_PAGE_PATH = "/users/accountants";

// Sims
export const FLEETS_SIMS_PAGE_PATH = "/sims/fleet";
export const AGENTS_SIMS_PAGE_PATH = "/sims/agent";
export const MASTERS_SIMS_PAGE_PATH = "/sims/master";
export const RESOURCES_SIMS_PAGE_PATH = "/sims/resource";
export const COLLECTORS_SIMS_PAGE_PATH = "/sims/collector";
